import { render, staticRenderFns } from "./Product_list.vue?vue&type=template&id=0cc10372&scoped=true&"
import script from "./Product_list.vue?vue&type=script&lang=js&"
export * from "./Product_list.vue?vue&type=script&lang=js&"
import style0 from "./Product_list.vue?vue&type=style&index=0&id=0cc10372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc10372",
  null
  
)

export default component.exports